import { useQuery } from "@tanstack/react-query";

import { listHolidays } from "@/adapters/api";
import { useActiveContext } from "@/store/use-active-context";
import type { HolidayItem } from "../types";

export function useHolidays(year: number) {
	const activeCanteiroId = useActiveContext((state) => state.activeCanteiroId);

	return useQuery({
		queryKey: ["holidays", activeCanteiroId, year],
		enabled: activeCanteiroId != null,
		queryFn: async (): Promise<HolidayItem[]> => {
			const { items } = await listHolidays(activeCanteiroId as string, year);
			return items
				.map((item) => ({
					id: item.id,
					date: item.date,
					name: item.name,
					source: item.source,
				}))
				.sort((a, b) => a.date.localeCompare(b.date));
		},
	});
}
